export default "__VITE_ASSET__BNzB4cCR__"